import React from "react"
import Seo from "./seo"
import Header from "./header";
import BouquetGame from "./BouquetGame";

const Layout = ({ title, children, description }) => {

  return (
    <>
      <Seo title={title} description={description}/>
      <div className={"h-full overflow-hidden"}>
        <div className="min-h-screen flex flex-col bg-wedding bg-no-repeat bg-center bg-cover bg-fixed items-stretch">
          <div>
            <Header/>
          </div>
          <div className="flex-grow flex flex-col">
            <div className="container px-4 xs:px-8 py-8 flex-grow">
              <main>{children}</main>
            </div>
            <footer className="text-center p-6 bg-primary text-white font-pretty h-36 sm:h-24">
              <div className="container flex flex-col justify-center h-full">
                <BouquetGame/>
              </div>
            </footer>
          </div>
        </div>
      </div>
    </>
  );
}


export default Layout
